import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchAppConfig, AppConfig } from "./appConfig.ts";
 
const MaintenanceContext = createContext<AppConfig | null>(null);
 
export const useMaintenance = () => useContext(MaintenanceContext);
 
export const MaintenanceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<AppConfig | null>(null);
 
  useEffect(() => {
    fetchAppConfig().then(setConfig).catch(() => {
      setConfig({ maintenanceMode: false, maintenanceMessage: "", showFunctionality: false }); // fallback
    });
  }, []);
 
  if (!config) return <div>Loading...</div>;

  if (!config.showFunctionality) {
    return (
      <div className="p-4 text-center" style={{fontSize:'20px', backgroundColor: '#f0fdf4'  }}>
          {config.maintenanceMessage}
</div>
    );
  }
 
  return (
<MaintenanceContext.Provider value={config}>
      {config.maintenanceMode && (
<div className="p-2 text-center" style={{fontSize:'20px', backgroundColor: '#f0fdf4' }}>
          {config.maintenanceMessage}
</div>
      )}
      {children}
</MaintenanceContext.Provider>
  );
};